// Single source of truth for routes where global chrome
// (GlobalSubheader + PlatformFooter) must be suppressed - full-screen flows,
// auth screens, embeds, and external-party signing/challenge links.
export const HIDDEN_CHROME_PREFIXES = [
  '/session',
  '/login',
  '/signup',
  '/auth',
  '/sso',
  '/embed',
  '/compliance/snapshot/',
  '/auth0-callback',
  '/florida/witness/',
  '/identity/challenge/',
  '/handoff/',
];

export const isChromeHidden = (pathname) =>
  HIDDEN_CHROME_PREFIXES.some((p) => pathname.startsWith(p));
